import React, { useEffect, useState } from "react";

import { Controller } from "react-hook-form";

// @mui
import { SxProps, Theme, Tooltip } from "@mui/material";
import styled from "@emotion/styled";

// common component
import MagicAutoCompleteSelect from "../../mui/AutoComplete";

// mui components
import FormControlLabel from "../../mui/FormControlLabel";
import FormHelperText from "../../mui/FormHelperText";
import FormControl from "../../mui/FormControl";
import RadioGroup from "../../mui/RadioGroup";
import Typography from "../../mui/Typography";
import TextField from "../../mui/TextField_new";
import Radio from "../../mui/Radio";
import Stack from "../../mui/Stack";
import Tabs from "../../mui/Tabs";
import Tab from "../../mui/Tab";
import Box from "../../mui/Box";

const tabIndicatorStyles: SxProps<Theme> = {
  bgcolor: "rgb(89, 89, 89)",
  height: "2px",
};

const tabSx: SxProps<Theme> = {
  padding: "3px 7px",
  textTransform: "capitalize",
  fontSize: "13px",
  color: "#242424",
  "&.Mui-selected": {
    fontWeight: 700,
    color: "#242424",
    backgroundColor: "#FEF7DA",
  },
};

const AddTargetForm: React.FC<any> = (props: any) => {
  const { control, centerOptions, targetParameterData, isEditablecenter } =
    props;

  const [activeTab, setActiveTab] = useState<number>(0);

  return (
    <Box>
      <Stack>
        <Controller
          name="createNewTargetFormData.center"
          control={control}
          rules={{ required: "Center is required" }}
          render={({ field, fieldState: { error } }) => (
            <StyledStack>
              <StyledTypography>Centre <span style={{ color: "red" }}> *</span></StyledTypography>
              <FormControl error={!!error} fullWidth>
                <MagicAutoCompleteSelect
                  {...field}
                  options={centerOptions?.centerSelect}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  value={field.value}
                  placeholder="Select Centre"
                  sx={{ background: "#FFF" }}
                  disabled={isEditablecenter}
                />
                <StyledFormHelperText>
                  {error ? error.message : " "}
                </StyledFormHelperText>
              </FormControl>
            </StyledStack>
          )}
        />

        <Controller
          name="createNewTargetFormData.bonusPoints"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <>
              <StyledTypography>Bonus point</StyledTypography>
              <FormControl error={!!error} fullWidth>
                <TextField
                  {...field}
                  id=""
                  placeholder="Enter Bonus Point"
                  error={!!error}
                  autoFocus
                  disabled={false}
                />
              </FormControl>
            </>
          )}
        />

        <Controller
          name="createNewTargetFormData.targetDuration"
          control={control}
          rules={{ required: "Region is required" }}
          render={({ field, fieldState: { error } }) => (
            <Box sx={{ mb: "0px" }}>
              <StyledTypography>Target duration <span style={{ color: "red" }}> *</span></StyledTypography>
              <FormControl error={!!error} fullWidth>
                <RadioGroup
                  {...field}
                  aria-labelledby="region-radio-buttons-group-label"
                  name="region-radio-buttons-group"
                  value={field.value}
                  defaultValue=""
                  onChange={(e) => field.onChange(e.target.value)}
                >
                  <StyledStack direction="row">
                    {["Quarterly", "Yearly"]?.map(
                      (radio: any, radioIndex: number) => (
                        <FormControlLabel
                          key={radioIndex}
                          control={
                            <Radio
                              sx={{
                                color: "#FFCA09",
                                "&.MuiRadio-root": {
                                  color: "#FFCA09",
                                },
                              }}
                            />
                          }
                          label={radio}
                          value={radio}
                        />
                      )
                    )}
                  </StyledStack>
                </RadioGroup>
                <StyledFormHelperText>
                  {error ? error.message : " "}
                </StyledFormHelperText>
              </FormControl>
            </Box>
          )}
        />

        <Controller
          name="createNewTargetFormData.malPractice"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <Box sx={{ mb: "0px" }}>
              <StyledTypography>Mal Pratice</StyledTypography>
              <FormControl error={!!error} fullWidth>
                <RadioGroup
                  {...field}
                  aria-labelledby="region-radio-buttons-group-label"
                  name="region-radio-buttons-group"
                  value={field.value}
                  defaultValue=""
                  onChange={(e) => field.onChange(e.target.value)}
                >
                  <StyledStack direction="row">
                    {["Yes", "No"]?.map((radio: any, radioIndex: number) => (
                      <FormControlLabel
                        key={radioIndex}
                        control={
                          <Radio
                            sx={{
                              color: "#FFCA09",
                              "&.MuiRadio-root": {
                                color: "#FFCA09",
                              },
                            }}
                          />
                        }
                        defaultChecked={field.value ? true : false}
                        label={radio}
                        value={radio == "Yes" ? true : false}
                      />
                    ))}
                  </StyledStack>
                </RadioGroup>
                <StyledFormHelperText>
                  {error ? error.message : " "}
                </StyledFormHelperText>
              </FormControl>
            </Box>
          )}
        />
      </Stack>

      {/* Tabs */}
      <Box sx={{ bgcolor: "rgb(255, 255, 255)", mb: "20px" }}>
        <Tabs
          value={activeTab}
          onChange={(event: React.SyntheticEvent, newValue: number) =>
            setActiveTab(newValue)
          }
          variant="fullWidth"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          sx={{ borderBottom: "1px solid rgb(222, 222, 227)" }}
          TabIndicatorProps={{
            sx: tabIndicatorStyles,
          }}
        >
          <Tab
            label={targetParameterData?.[0]?.name || "Programme performance"}
            sx={tabSx}
          />
          <Tab
            label={targetParameterData?.[1]?.name || "Quality and efficiency"}
            sx={tabSx}
          />
        </Tabs>
      </Box>

      {/* Programme Performance Field */}
      {/* <Stack sx={{ display: activeTab ? "none" : "block" }}>
        {targetParameterData["Programme performance"]?.map(
          ([category, parameters]: [string, any], index: number) => (
            <Stack key={index}>
              {Object.entries(parameters)?.map(([paramName, paramValue]: any) =>
                paramValue.map(({ id, name, validationMsg }: any) => (
                  <Controller
                    key={id} // Unique key for each Controller
                    name={`createNewTargetFormData.programmePerformance.${id}`}
                    control={control}
                    rules={{
                      required: validationMsg,
                      validate: (value) =>
                        /^-?\d+(\.\d{1,2})?$/.test(value) ||
                        `${name} must be a valid number`,
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <StyledStack>
                        <StyledHeading sx={{ marginBottom: "10px" }}>
                          <Tooltip title={category}>
                            <span>
                              {category.length < 50
                                ? category
                                : `${category.slice(0, 50)}...`}
                            </span>
                          </Tooltip>
                        </StyledHeading>
                        <StyledTypography>
                          <Tooltip title={name}>
                            <span>
                              {name.length < 50
                                ? name
                                : `${name.slice(0, 50)}...`}
                            </span>
                          </Tooltip>
                        </StyledTypography>
                        <FormControl error={!!error} fullWidth>
                          <StyledTextField
                            {...field}
                            onChange={(e: any) =>
                              field.onChange(e.target.value)
                            }
                            id={id}
                            placeholder="Enter number"
                            size="small"
                            value={field.value || ""}
                          />
                          <StyledFormHelperText>
                            {error ? error.message : " "}
                          </StyledFormHelperText>
                        </FormControl>
                      </StyledStack>
                    )}
                  />
                ))
              )}
            </Stack>
          )
        )}
      </Stack> */}

      <Stack sx={{ display: activeTab ? "none" : "block" }}>
        {Object.entries(targetParameterData["Programme performance"])?.map(
          ([Key, value]: any, index: number) => (
            <Stack key={index}>
              <StyledHeading sx={{ marginBottom: "10px" }}>
                <Tooltip title={Key}>
                  <span>
                    {Key.length < 50 ? Key : `${Key.slice(0, 50)}...`}
                  </span>
                </Tooltip>
              </StyledHeading>
              {value.map(({ id, name, validationMsg }: any) => (
                <Controller
                  key={id} // Unique key for each Controller
                  name={`createNewTargetFormData.programmePerformance.${id}`}
                  control={control}
                  rules={{
                    required: validationMsg,
                    validate: (value) =>
                      /^-?\d+(\.\d{1,2})?$/.test(value) ||
                      `${name} must be a valid number`,
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <StyledStack>
                      <StyledTypography>
                        <Tooltip title={name}>
                          <span>
                            {name.length < 50
                              ? name
                              : `${name.slice(0, 50)}...`}<span style={{ color: "red" }}> *</span>
                          </span>
                        </Tooltip>
                      </StyledTypography>
                      <FormControl error={!!error} fullWidth>
                        <StyledTextField
                          {...field}
                          onChange={(e: any) => field.onChange(e.target.value)}
                          id={id}
                          placeholder="Enter number"
                          size="small"
                          value={field.value == undefined ? "" : field?.value}
                        />
                        <StyledFormHelperText>
                          {error ? error.message : " "}
                        </StyledFormHelperText>
                      </FormControl>
                    </StyledStack>
                  )}
                />
              ))}
            </Stack>
          )
        )}
      </Stack>

      {/* Quality And Efficacy Field */}
      <Stack sx={{ display: activeTab ? "block" : "none" }}>
        {Object.entries(targetParameterData["Quality and efficacy"])?.map(
          ([Key, value]: any, index: number) => (
            <Stack key={index}>
              <StyledHeading sx={{ marginBottom: "10px" }}>
                <Tooltip title={Key}>
                  <span>
                    {Key.length < 50 ? Key : `${Key.slice(0, 50)}...`}
                  </span>
                </Tooltip>
              </StyledHeading>
              {value.map(({ id, name, validationMsg }: any) => (
                <Controller
                  key={id} // Unique key for each Controller
                  name={`createNewTargetFormData.qualityAndEffiancy.${id}`}
                  control={control}
                  rules={{
                    required: validationMsg,
                    validate: (value) =>
                      /^-?\d+(\.\d{1,2})?$/.test(value) ||
                      `${name} must be a valid number`,
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <StyledStack>
                      <StyledTypography>
                        <Tooltip title={name}>
                          <span>
                            {name.length < 50
                              ? name
                              : `${name.slice(0, 50)}...`}<span style={{ color: "red" }}> *</span>
                          </span>
                        </Tooltip>
                      </StyledTypography>
                      <FormControl error={!!error} fullWidth>
                        <StyledTextField
                          {...field}
                          onChange={(e: any) => field.onChange(e.target.value)}
                          id={id}
                          placeholder="Enter number"
                          size="small"
                          value={field.value == undefined ? "" : field?.value}
                        />
                        <StyledFormHelperText>
                          {error ? error.message : " "}
                        </StyledFormHelperText>
                      </FormControl>
                    </StyledStack>
                  )}
                />
              ))}
            </Stack>
          )
        )}
      </Stack>
    </Box>
  );
};

const StyledTypography = styled(Typography)(() => ({
  fontWeight: 550,
  color: "#242424",
  fontSize: "13px",
  cursor: "pointer",
}));
const StyledFormHelperText = styled(FormHelperText)(() => ({
  marginLeft: "1px",
  marginBottom: "20px",
  marginTop: "-2px",
}));
const StyledStack = styled(Stack)(() => ({
  marginBottom: "-10px",
}));
const StyledTextField = styled(TextField)(() => ({
  marginBottom: "8px",
}));
const StyledHeading = styled(Typography)(() => ({
  color: "#9E9E9E",
  fontWeight: 600,
  fontSize: "14px",
  cursor: "pointer",
}));

export default AddTargetForm;
